import React from 'react'
//import selectn from 'selectn'
import { getPlayerRoles } from '../../lib/utils/common'
import { PlayerStats } from './index'

/**
 * Display stats for a bowler for lite view (featurephone)
 *
 * @param {Object} bowler   bowler details
 * @param {Number}  bId     bowler iterator (0,1,2 etc)
 * @return {React.Element}  bowler stats for featurephone
 */
export const BowlerLite = ({
  bowler = {},
  bId
}) => {

  let stats = bowler.stats || []
  // Only 4 stats on one line, remaining stats need to be pushed to next
  let secondSet = stats.splice(4) || []
  //let runsScored = selectn('[0].value', stats)
  return (
    <tr className="cricinfo__table__tr" key={bId}>
      <td colSpan="2" className="cricinfo__table__td">
        <ul className="cricinfo__table__list">
          <li className="cricinfo__table__list__item"
            dangerouslySetInnerHTML={getPlayerRoles(bowler.name, bowler.roles)}>
          </li>
          <PlayerStats stats={stats} />
          <PlayerStats stats={secondSet} />
        </ul>
      </td>
    </tr>
  )

}

export default BowlerLite



// WEBPACK FOOTER //
// ../app/components/common/BowlerLite.jsx